import { OrderCreditsBy } from "gen/search/service/service_pb"
import { FilterT } from "shared-ts/hooks/useFilter/types/filter.types"
import { SortProps } from "shared-ts/hooks/useSort"
import { TableProps } from "shared-web/components/composite/TableV2/Table"
import { TableCellHeight } from "shared-web/components/composite/TableV2/TableCell"
import { useTable } from "shared-web/components/composite/TableV2/useTable"
import { ListSearchInputProps } from "shared-web/hooks/useListKeyboardNavigation"

import { urls } from "urls"

import { useCreditsTableColumns } from "./useCreditsTableColumns"
import { useCreditsTableFilters } from "./useCreditsTableFilters"
import { useCreditsTableSort } from "./useCreditsTableSort"
import { useCreditsTableSearch } from "../../data"

interface UseCreditsTableRes {
  tableProps: TableProps
  sortProps: SortProps<OrderCreditsBy>
  filters: FilterT[]
  searchQuery: string
  setSearchQuery: (query: string) => void
  searchInputProps: ListSearchInputProps
}

export function useCreditsTable(): UseCreditsTableRes {
  const columns = useCreditsTableColumns()
  const { sortProps, orderBy, order } = useCreditsTableSort()
  const {
    filters,
    selectedCustomerIds,
    selectedDateRange,
    selectedStatuses,
    selectedTransactionTypes,
  } = useCreditsTableFilters()

  const {
    creditTableLineItems,
    searchQuery,
    setSearchQuery,
    isLoading,
    isError,
    loadNext,
  } = useCreditsTableSearch({
    customerIds: selectedCustomerIds,
    orderBy,
    order,
    selectedDateRange,
    selectedStatuses,
    selectedTransactionTypes,
  })

  const { tableProps, searchInputProps } = useTable({
    data: creditTableLineItems,
    columns,
    cellHeight: TableCellHeight.Small,
    extractRowKey: (row) => row.id.toString(),
    isError,
    isLoading,
    onLastRowInView: loadNext,
    extractRowHref: (row) => urls.credit(row.id),
    enableKeyboardNavigation: true,
  })

  return {
    tableProps,
    sortProps,
    filters,
    searchQuery,
    setSearchQuery,
    searchInputProps,
  }
}
